const SUB_STEP_INTERVAL_MS = 2000;

const STAGES: string[][] = [
    ['Analysiere dein Foto...', 'Perspektive wird erkannt...', 'Raum wird analysiert...', 'Wir schauen uns deinen Raum an...'],
    [
        'Der perfekte Platz wird gesucht...',
        'Objekt wird platziert...',
        'Position wird berechnet...',
        'Größe wird angepasst...',
        'Ein bisschen nach links...',
        'Details werden verfeinert...',
        'Licht wird abgestimmt...',
        'Schatten werden erzeugt...',
    ],
    ['Letzte Anpassungen...', 'Letzter Feinschliff...', 'Fast fertig...', 'Vorschau wird gerendert...'],
];

export class DialogProgressController {
    private intervalId: number | null = null;

    constructor(
        private figureElement: HTMLElement,
        private figcaptionElement: HTMLElement
    ) {}

    public start(): void {
        this.stop();
        this.figureElement.setAttribute('aria-busy', 'true');
        this.figcaptionElement.setAttribute('aria-live', 'polite');
        this.startStage(0);
    }

    /*                                                                       */
    public setProgress(progress: number): void {
        if (progress >= 90) {
            this.startStage(2, false);
        } else if (progress >= 50) {
            this.startStage(1, false);
        }
    }

    public stop(): void {
        this.clearCurrentInterval();
        this.figureElement.setAttribute('aria-busy', 'false');
    }

    private startStage(stageIndex: number, showFirstStepImmediately = true): void {
        this.clearCurrentInterval();
        const steps = STAGES[stageIndex];
        let index = showFirstStepImmediately ? 0 : -1;

        if (showFirstStepImmediately) {
            this.figcaptionElement.textContent = steps[0];
        }

        this.intervalId = window.setInterval(() => {
            index++;
            if (index < steps.length) {
                this.figcaptionElement.textContent = steps[index];
            } else {
                this.clearCurrentInterval();
            }
        }, SUB_STEP_INTERVAL_MS);
    }

    private clearCurrentInterval(): void {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}
